export default {
    menu: [
        {
            label: '首页',
            url: '/dashboard',
            icon: 'el-icon-package'
        },
        {
            label: '活动管理',
            icon: 'el-icon-package',
            url: '/activity/main'
        },
        {
            label: '报名管理',
            icon: 'el-icon-package',
            url: '/signup/list'
        },
        {
            label: '照片管理',
            icon: 'el-icon-package',
            url: '/picture/list'
        },
        {
            label: '问卷配置',
            icon: 'el-icon-package',
            url: 'https://deep-uat.apps.saic-gm.com/chain/'
            // "url": "https://deep-uat.apps.saic-gm.com/chain/",
        },
        {
            label: '线索管理',
            icon: 'el-icon-package',
            url: '/clue/main'
        },
        // {
        //     label: '素材管理',
        //     icon: 'el-icon-package',
        //     url: '/material/list'
        // },
        {
            "label": "素材管理",
            "icon": "el-icon-package",
            children: [
                {
                    "label": "图片管理",
                    "url": "/material/list",
                    "icon": "el-icon-package"
                },
                {
                    "label": "视频管理",
                    "url": "/video/list",
                    "icon": "el-icon-package"
                },

            ]
        },
        {
            "label": "核销管理",
            "icon": "el-icon-package",
            children: [
                {
                    "label": "核销人员管理",
                    "url": "/verification/worker",
                    "icon": "el-icon-package"
                }
            ]
        }
        // {
        //     label: "权限管理",
        //     icon: 'el-icon-setting',
        //     children: [
        //         {
        //             label: "应用权限管理",
        //             url: "/permission"
        //         },
        //     ]
        // }
    ],

    topMenu: []
};
